<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'INTRO.TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="intro-container">
    <h1 [innerHTML]="'INTRO.WELCOME' | translate"></h1>
    <p class="intro-description">{{ 'INTRO.DESCRIPTION' | translate }}</p>

    <ion-card button="true" (click)="selectType('pre-existing')" class="selection-card">
      <div class="card-content-wrapper">
        <div class="icon-container">
          <i class="icon-pre-existing-diabetes intro-icon"></i>
        </div>
        <div class="text-container">
          <h2 class="card-title">{{ 'INTRO.PRE_EXISTING' | translate }}</h2>
          <p class="card-desc">{{ 'INTRO.PRE_EXISTING_DESC' | translate }}</p>
        </div>
      </div>
    </ion-card>

    <ion-card button="true" (click)="selectType('gestational')" class="selection-card">
      <div class="card-content-wrapper">
        <div class="icon-container">
          <i class="icon-gestational-diabetes intro-icon"></i>
        </div>
        <div class="text-container">
          <h2 class="card-title">{{ 'INTRO.GESTATIONAL' | translate }}</h2>
          <p class="card-desc">{{ 'INTRO.GESTATIONAL_DESC' | translate }}</p>
        </div>
      </div>
    </ion-card>
  </div>
</ion-content>
